export default {
    entityKey: 'executions',
    titles: {
        singular: 'Execution',
        plural: 'Executions'
    }
}
